import React, { useState } from 'react';
import { LONGITUDINAL_VIEW_TEXT } from '../../constants/constant';
// import { IoIosArrowForward } from 'react-icons/io';
import wavetoggel from '../../assets/images/wave-toggle.svg';
import promptIcon from '../../assets/images/prompt-icon.svg';
import ButtonComponent from '../uikit/components/Button/ButtonComponent';
import applyIcon from '../../assets/images/filter-icon-chart.svg';
import CustomTooltip from '../uikit/components/Tooltip/Tooltip';

const WaveSelector = ({ waveData, selectedOptions, onOptionChange, onApplySelections,selectedPrompt }) => {
  // State to track which waves are expanded
  const [expandedWaves, setExpandedWaves] = useState({});
  // Add state to track selected radio button
  const [selectedRadio, setSelectedRadio] = useState({});

  // Convert waveData object keys to array and sort them
  const waves = Object.keys(waveData || {})
    .map(wave => wave.substring(1)) // Remove 'W' prefix
    .sort((a, b) => parseInt(a) - parseInt(b)); // Sort numerically

  // Toggle wave expansion
  const toggleWave = (waveIndex) => {
    setExpandedWaves(prev => ({
      ...prev,
      [waveIndex]: !prev[waveIndex]
    }));
  };

  const formatLabel = (label) => {
    // Remove .xlsx extension and any path
    return label.split('.xlsx')[0].split('/').pop();
  };

  const capitalizeFirstLetter = (string) => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
  };

  // Modify the radio button click handler
  const handleOptionChange = (waveIndex, optionIndex, requestId) => {
    // Check if this option is currently selected
    const isCurrentlySelected = selectedRadio[waveIndex] === optionIndex;
    
    if (isCurrentlySelected) {
      // If it's selected, deselect it
      setSelectedRadio(prev => {
        const newState = { ...prev };
        delete newState[waveIndex];
        return newState;
      });
      // Clear the selection from parent component
      onOptionChange(waveIndex, null, null);
    } else {
      // If it's not selected, select it and deselect others in the same wave
      setSelectedRadio(prev => ({
        ...prev,
        [waveIndex]: optionIndex
      }));
      // Update parent with new selection
      onOptionChange(waveIndex, optionIndex, requestId);
    }
  };

  return (
    <div className="wave-selector">
      <div className="prompt">
        <div className="prompt-header">
          <img src={promptIcon} alt="prompt-icon" className='prompt-icon' />
          <span className="wave-option-heading">
            {capitalizeFirstLetter(selectedPrompt)}
          </span>
          <ButtonComponent
            className="apply-selections-btn"
            onClick={onApplySelections}
            btnType="secondary"
            text="Apply"
            icon={applyIcon}
            sx={{
              width: "91px",
              height: "32px",
              backgroundColor: "#EBEBFF",
              '&:hover': {
                backgroundColor: "#EBEBFF",
              },
              color: "#4F46E5",
              fontSize: "14px",
              textTransform: "none",
              minWidth: "91px",
              padding: "6px 12px",
              gap: "8px"
            }}
          />
          {/* <ButtonComponent
                  className="downloadbtn"
                  btnType="secondary"
                  text="Download Output"
                  onClick={handleDownloadClicked}
                  sx={{
                    width: "181px",
                    padding: "13px 13px 13px 30px",
                    height: "38px",
                    paddingleft: "30px",
                  }}
                /> */}
        </div>
        <div className="waves">
          {Object.entries(waveData || {}).map(([wave, files], waveIndex) => {
            // Extract wave number from the wave key (e.g., "W10" -> "10")
            const waveNumber = wave.substring(1); // Remove 'W' prefix
console.log(waveNumber)
            return (
              <div key={wave} className="wave-group">
                <div
                  className="wave-header"
                  onClick={() => toggleWave(waveIndex)}
                >
                  {/* <IoIosArrowForward 
                    className={`arrow-icon ${isExpanded ? 'expanded' : ''}`}
                  /> */}
                  <img
                    src={wavetoggel}
                    alt="wave-toggle"
                    className={`arrow-icon ${expandedWaves[waveIndex] ? 'expanded' : ''}`}
                  />
                  <div className='wave-number'>{`Wave ${waveNumber}`}</div>
                </div>
                {expandedWaves[waveIndex] && (
                  <div className="options">
                    {files.map((file, optionIndex) => (
                      <div className="option" key={optionIndex}>
                        <input
                          type="checkbox"
                          name={`wave-${waveIndex}`}
                          checked={selectedRadio[waveIndex] === optionIndex && selectedOptions[waveIndex]?.optionIndex === optionIndex}
                          onChange={() => handleOptionChange(waveIndex, optionIndex, file.unified_id)}
                        />
                        <CustomTooltip title={file.actual_file_name}>
                          <span className="option-label">
                            {formatLabel(file.actual_file_name)}
                          </span>
                        </CustomTooltip>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WaveSelector; 